import { mapGetters, mapState } from 'vuex';

export default {
	created() {
		if (!this.contentAvailable) {
			Promise.all([
				this.fetchContent('posts'),
				this.fetchContent('pages'),
				this.fetchContent('galleries'),
				this.fetchContent('playlists'),
				this.fetchContent('forms'),
				this.fetchContent('media'),
				this.fetchContent('mainMenu'),
			]).then(() => {
				// content now available
				this.$store.commit('contentData/updateContentAvailable', true);

				// set up data sources
				// TODO FOOTER MENU SETTING
				let fmid = -1;
				if (this.$store.state.CID === 1) {
					fmid = 19;
				}
				if (this.$store.state.CID === 2) {
					fmid = 19;
				}
				if (fmid >= 0) {
					this.$store.commit('contentData/updateData', { target: 'footerMenu', newValue: this.allMenus.find(e => e.id === fmid).childrenArray });
				}
			});
		}
	},
	methods: {
		fetchContent(target) {
			return this.$store.dispatch('contentData/fetchData', target);
		},
		findInMedia(id) {
			return this.getContent('media').find(e => e.id === id);
		},
	},
	computed: {
		...mapState('contentData', {
			contentAvailable: 'contentAvailable',
			mainMenu: 'mainMenu',
			footerMenu: 'footerMenu',
		}),
		...mapGetters('contentData', {
			getContent: 'getData',
			getContentById: 'getDataById',
		}),
	},
};
